/** @format */

import { head, tail, isEmpty } from 'fe-lib-sequences'

const recCompose = (hocs = [], Comp) =>
  isEmpty(hocs) ? Comp : recCompose(tail(hocs), head(hocs)(Comp))

export const compose = (...hocs) => Comp => recCompose(hocs.reverse(), Comp)
